<template>
  <div id="menuFrame">
    <div id="header">
      <div class="logo">
        <router-link :to="{name: 'appIndex', params: {}}">
          <img class="logoImg" src="./img/logo.png">
        </router-link>
      </div>
      <div class="h_title">友途CRM管理系统</div>
      <div class="headBox">
        <div class="searchBar"></div>
        <ul class="settings">
          <!--<li class="lay-f-l">消息</li>-->
          <!--<li class="lay-f-l">服务</li>-->
          <li class="head lay-f-l">
            <img class="dsg-radiusCircle" src="https://oss.aliyuncs.com/aliyun_id_photo_bucket/default_handsome.jpg">
            <ul class="head_ul">
              <li @click="signOut()">退出</li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <div id="appMenu">
      <ul class="navBox">
        <li class="nav" v-for="item in menus" :key="item.routeName">
          <a @click="gotoMenu(item)"
             :class="{'active': checkFstMenuActive(item)}"><i :class="item.icon"></i>{{item.title}}</a>
        </li>
      </ul>
      <!--  -->
      <ul id="subNavBox" v-if="currentFstMenu.children" :class="{'fold': ifSubMenuFold}">
        <div class="menuTitle">{{currentFstMenu.title}}</div>
        <li v-for="item in currentFstMenu.children"
            :key="item.routeName"
            v-if="typeof item.show == 'undefined' || item.show == 'true'">
          <a @click="gotoSubMenu(item)"
             :class="{'active': checkSndMenuActive(item)}"
             v-if="!item.children">{{item.title}}</a>
          <div @click="foldThrMenu(item)"
               :class="{'folding': item.fold}"
               v-else>
            <div class="nav-icon">
              <i :class="{
                'fa': true, 'fa-caret-down': !item.fold,
                'fa-caret-right': item.fold
              }"
              ></i>
            </div>
            {{item.title}}
          </div>
          <ul class="thdNavBox">
            <li v-for="item2 in item.children"
                :key="item2.routeName">
              <a @click="gotoThdMenu(item, item2)" :class="{'active': crumbObj.length > 2 ? crumbObj[2].routeName == item2.routeName : ''}">{{item2.title}}</a>
            </li>
          </ul>
        </li>
      </ul>
      <div class="hideMenu" @click="foldSubMenu" :class="{'fold': ifSubMenuFold}">
        <div class="hm_bg-fold" v-if="ifSubMenuFold">
          <i class="fa fa-chevron-left indent"></i>
        </div>
        <div class="hm_bg-unfold" v-if="!ifSubMenuFold">
          <i class="fa fa-chevron-left"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'menuFrame',
  data () {
    return {
      ifSubMenuFold: false, // 是否折叠二级菜单栏
      currentFstMenu: {},
      currentSubMenu: {},
      currentThdMenu: {},
      crumbObj: [],
      managerId: '',
      userType: '',
      ifAuditor: sessionStorage.getItem('ifAuditor'), // 是否有审核权限，登录时赋值
      menus: [
        {
          title: '首页',
          routeName: 'appIndex',
          icon: 'el-icon-menu'
        },
        /* {
          title: '客户管理',
          routeName: 'clientManage',
          icon: 'el-icon-user-solid',
          children: [
            {
              title: '我的客户',
              routeName: 'myClient'
              // children: [
              //   {
              //     title: '客户信息查询',
              //     routeName: 'customerCheck',
              //     icon: 'fa fa-vcard-o'
              //   }
              // ]
            },
            {
              title: '全部客户',
              routeName: 'allClient'
            }
          ]
        },
        {
          title: '任务管理',
          routeName: 'taskManage',
          icon: 'el-icon-tickets',
          children: [
            {
              title: '我的任务',
              routeName: 'myTask'
            },
            {
              title: '已创建任务',
              routeName: 'isTruetask'
            }
          ]
        },
        {
          title: '服务推荐',
          routeName: 'serveRecd',
          icon: 'el-icon-collection-tag',
          children: [
            {
              title: '商品推荐',
              routeName: 'ProductRecd'
            },
            {
              title: '活动推荐',
              routeName: 'activityRecd'
            },
            {
              title: '商家推荐',
              routeName: 'storeRecd'
            }
          ]
        },
        {
          title: '订单查询',
          routeName: 'orderQuery',
          icon: 'el-icon-search',
          children: [
            {
              title: '专属客户订单',
              routeName: 'clientOrder'
            },
            {
              title: '全部订单',
              routeName: 'allOrder'
            }
          ]
        },
        {
          title: '建行双签用户',
          routeName: 'jianhangUser',
          icon: 'el-icon-wallet'
        }, */
        {
          title: '用户标签库管理',
          routeName: 'userLabelManage',
          icon: 'el-icon-s-flag'
        },
        {
          title: '批量打标签库',
          routeName: 'userLabelCheck',
          icon: 'el-icon-s-check'
        }
        /*,
        {
          title: '角色及权限',
          routeName: 'roleAndPermission',
          icon: 'fa fa-user-plus',
          children: [
            {
              title: '运算中心',
              routeName: '',
              children: [
                {title: '卡片中心', routeName: 'card'},
                {title: '任务中心', routeName: 'task'},
                {title: '任务记录', routeName: 'taskLog'},
                {title: '执行单次任务', routeName: 'oneTimeTask'}
              ]
            },
            {
              title: '角色管理',
              routeName: 'roleManage'
            },
            {
              title: '账号管理',
              routeName: 'accountManage'
            }
          ]
        }
        */
      ]
    };
  },
  created () {
    // document.domain = '192.168.3.65';
    // window.platform = 'adminCRM';
    /*
    if (!sessionStorage.getItem('ifAuditor')) {
      this.signOut();
      return this.$message.info('请登录');
    }
    */
    /* this.axios.get(`/doubleTask/getManagerId`, {}).then(res => {
      this.managerId = res.data.resultData.managerId;
      this.userType = res.data.resultData.userType;
    }); */
    this.$nextTick(() => {
      this.computeWindowHeight();
      window.onresize = () => {
        this.computeWindowHeight();
      };
      this.menus.forEach(e => {
        let curRouteType = this.$route.path.match(/^\/[a-z]+/)[0].split('/')[1];
        if (this.$route.name === e.routeName && curRouteType === e.routeType) {
          this.currentFstMenu = e;
          this.forRouteName(this.currentFstMenu);
          return e.iframeUrl === this.$route.path;
        } else if (this.$route.matched.length === 1) {
          if (e.routeName === this.$route.matched[0].name) {
            this.currentFstMenu = e;
          }
        } else {
          if (e.routeName === this.$route.matched[1].name) {
            this.currentFstMenu = e;
          }
        }
      });
      if (this.currentFstMenu.children) {
        this.currentSubMenu = this.currentFstMenu.children[0];
        if (this.currentSubMenu.children) {
          this.currentThdMenu = this.currentSubMenu.children[0];
        }
      }
      if (this.$route.matched.length === 3) {
        this.currentThdMenu = {};
        // this.currentSubMenu = this.currentFstMenu.children.find(e => e.routeName === this.$route.matched[2].name);
        this.currentSubMenu = this.forRouteName(this.currentFstMenu);
      }
      if (this.$route.matched.length === 4) {
        this.currentThdMenu = {};
        this.currentSubMenu = this.currentFstMenu.children.find(e => e.routeName === this.$route.matched[2].name);
        // this.currentThdMenu = this.currentSubMenu.children.find(e => e.routeName === this.$route.matched[3].name);
        this.currentThdMenu = this.forRouteName(this.currentSubMenu);
      }
      this.$nextTick(() => {
        this.resetFrameContent();
      });
    });
  },
  methods: {
    // 加载一级菜单
    gotoMenu (obj) {
      console.log(obj);
      // if ((obj.routeName !== 'appIndex') && this.userType === 2) {
      //   this.$message.warning('抱歉，暂无权限查看！');
      // } else {
      this.currentFstMenu = obj;
      this.currentSubMenu = {};
      this.currentThdMenu = {};
      this.$store.state.iframeUrl = '';
      if (!obj.children && obj.routeName) {
        this.$router.push({name: obj.routeName});
      } else if (obj.children && obj.routeName) {
        if (obj.children[0].children) {
          this.gotoThdMenu(obj.children[0], obj.children[0].children[0]);
        } else {
          this.gotoSubMenu(obj.children[0]);
        }
      }
      this.$nextTick(() => {
        this.resetFrameContent();
      });
      // }
    },
    // 加载二级菜单
    gotoSubMenu (obj) {
      if ((obj.routeName === 'allClient' || obj.routeName === 'allOrder' || obj.routeName === 'isTruetask') && this.userType === 1) {
        this.$message.warning('抱歉，暂无权限查看！');
      } else {
        this.currentSubMenu = obj;
        this.currentThdMenu = {};
        this.$store.state.iframeUrl = '';
        if ('iframeUrl' in obj && obj.iframeUrl) {
          this.$store.state.iframeUrl = obj.iframeUrl;
          this.$router.push({path: obj.iframeUrl});
        } else if (obj.routeName) {
          this.$router.push({name: obj.routeName});
        }
      }
    },
    // 加载三级菜单
    gotoThdMenu (obj, obj2) {
      this.currentSubMenu = obj;
      this.currentThdMenu = obj2;
      this.$store.state.iframeUrl = '';
      if (this.currentRouteName === 'allClient' && this.userType === 1) {
        this.$message.warning('抱歉，暂时此权限查看！');
      }
      if (this.currentRouteName === 'allOrder' && this.userType === 1) {
        this.$message.warning('抱歉，暂时此权限查看！');
      }
      if ('iframeUrl' in obj && obj.iframeUrl) {
        this.$store.state.iframeUrl = obj.iframeUrl;
      } else if (obj2.routeName) {
        this.$router.push({name: obj2.routeName});
      } else if (obj2.url) {
        window.location.href = obj2.url;
      }
    },
    // 折叠二级菜单
    foldSubMenu () {
      this.ifSubMenuFold = !this.ifSubMenuFold;
    },
    // 折叠菜单
    foldThrMenu (obj) {
      if (typeof obj.fold === 'undefined') {
        this.$set(obj, 'fold', false);
      }
      if (obj.fold) {
        obj.fold = false;
      } else {
        obj.fold = true;
      }
      this.currentSubMenu = obj;
      this.currentThdMenu = {};
      this.$store.state.iframeUrl = '';
      if ('iframeUrl' in obj && obj.iframeUrl) {
        this.$store.state.iframeUrl = obj.iframeUrl;
        this.$router.push({path: obj.iframeUrl});
      } else if (obj.routeName) {
        this.$router.push({name: obj.routeName});
      }
    },
    // 检测是否有二级菜单，自动展开内容区域的width
    resetFrameContent () {
      let subMenu = document.getElementById('subNavBox');
      let frame = document.getElementById('frameContent');
      // let clientW = document.body.clientWidth;
      if (subMenu) {
        frame.style.marginLeft = '';
        // frame.style.left = '230px';
        // frame.style.width = clientW - 230 + 'px';
      } else {
        frame.style.marginLeft = '50px';
        // frame.style.left = '50px';
        // frame.style.width = clientW - 50 + 'px';
      }
    },
    // 判断一级菜单是否高亮
    checkFstMenuActive (item) {
      let curFstPath = this.$route.path.match(/^\/[a-z]+/)[0].split('/')[1];
      if (this.$route.name === 'frame') {
        if (item.routeType === curFstPath) {
          return true;
        }
      } else {
        return this.crumbObj.length > 0 ? this.crumbObj[0].routeName === item.routeName : false;
      }
    },
    // 判断二级菜单是否高亮
    checkSndMenuActive (item) {
      if (this.$route.name === 'frame') {
        if (item.iframeUrl === this.$route.path) {
          return true;
        }
      } else {
        return this.crumbObj.length > 1 ? this.crumbObj[1].routeName === item.routeName : '';
      }
    },
    // 计算屏幕高，赋值给菜单栏
    computeWindowHeight () {
      if (document.getElementById('appMenu')) {
        document.getElementById('appMenu').style.height = document.body.clientHeight + 'px';
      }
      if (document.getElementById('frameContent')) {
        document.getElementById('frameContent').style.height = document.body.clientHeight - 50 + 'px';
      }
    },
    // 登出
    signOut () {
      this.axios.get(`/admin/internal/user/logout?source=internal`)
        .then(res => {
          if (res.data.errorCode == 0) {
            sessionStorage.clear();
            this.$router.replace({name: 'login'});
            this.$message.success(res.data.data);
          } else {
            this.$message.error(res.data.errorMsg);
          }
        });
    },
    // 递归查找routeName，生成面包屑导航栏数据
    forRouteName (obj) {
      let result = {};
      this.crumbObj = [];
      let parentNode = null;
      let node = null;
      let fn = (json, queryObj) => {
        // 1.第一层 root 深度遍历整个JSON
        for (var i = 0; i < json.length; i++) {
          if (node) {
            break;
          }
          var o = json[i];
          // 没有就下一个
          if (!o || !o.routeName) {
            continue;
          }
          let ifRight = false;
          // 1.5 如果加载的是iframe类型的
          if (queryObj.name === 'frame') {
            ifRight = o.iframeUrl === queryObj.path;
          } else {
            ifRight = o.routeName === queryObj.name;
          }
          // 2.有节点就开始找，一直递归下去
          if (ifRight) {
            // 找到了与queryObj匹配的节点，结束递归
            node = o;
            this.crumbObj.push(node);
            break;
          } else {
            // 3.如果有子节点就开始找
            if (o.children) {
              // 4.递归前，记录当前节点，作为parent 父亲
              parentNode = o;
              this.crumbObj.push(parentNode);
              // 递归往下找
              fn(o.children, queryObj);
            } else if (o.crumbTree) {
              // 4.递归前，记录当前节点，作为parent 父亲
              parentNode = o;
              this.crumbObj.push(parentNode);
              // 递归往下找
              fn(o.crumbTree, queryObj);
            } else {
              // 跳出当前递归，返回上层递归
              continue;
            }
          }
        }

        // 5.如果木有找到父节点，置为null，因为没有父亲
        if (!node) {
          parentNode = null;
          this.crumbObj.splice(this.crumbObj.indexOf(parentNode), 1);
        }

        // 6.返回结果o
        result = node;
        return result;
      };
      fn([obj], this.$route);
      this.$store.state.crumbArr = this.crumbObj;
      return result;
    }
  },
  watch: {
    '$route' () {
      this.forRouteName(this.currentFstMenu);
    }
  }
};
</script>

<style lang="scss" scoped>
  $nav-height: 50px;
  #menuFrame{font-size: 14px;}
  #header{position: relative; z-index: 3; width: 100%; height: $nav-height; background-color: $base-bgcolor; text-align: right; font-size: 14px; color: #fff;}
  .logo{
    float: left; width: 50px; height: $nav-height; cursor: pointer;
    &:hover{background-color: $base-bgcolor-hover;}
    img{width: 50px;}
  }
  .h_title{float: left; height: $nav-height; line-height: $nav-height; padding-left: 10px;}
  .name{
    float: left; width: 100px; height: $nav-height; line-height: $nav-height; text-align: center; cursor: pointer;
    &:hover{background-color: $base-bgcolor-hover;}
  }
  .headBox{height: 100%;}
  .settings{
    display: inline-block; position: relative;
    li{
      height: $nav-height; line-height: $nav-height; padding: 0 12px; cursor: pointer;
      &:hover{background-color: $base-bgcolor-hover;}
    }
    li.head{
      position: relative; display: inline-flex; align-items: center; justify-content: center; width: 50px; padding: 0;
      img{width: 35px; height: 35px;}
      &:hover{background-color: $base-bgcolor-hover;}
      &:hover .head_ul{display: block;}
    }
  }
  .head_ul{
    display: none; position: absolute; right: 0; top: 50px; width: 200px; background-color: $base-bgcolor-hover; text-align: center;
    li{height: 50px;}
  }

  #appMenu{position: relative; float: left; width: auto; min-width: 50px; height: 100%;
    margin: -50px 20px 0 0; text-align: left; font-size: 12px; color: #fff;}
  .navBox{
    position: absolute; left: 0; z-index: 2; width: 50px; height: 100%; padding-top: 50px; background-color: $base-bgcolor; overflow: hidden; transition: all 300ms;
    &:hover{width: 230px;}
    li{
      width: 230px; cursor: pointer;
      &:hover{
        background-color: $base-bgcolor-hover; color: $theme-color-blue;
        & i{color: #fff;}
      }
    }
    li i{width: 50px; height: $nav-height; line-height: $nav-height; text-align: center; font-size: 16px; color: #b3b5b6;}
    li > a{
      display: block; height: 100%; color: #fff;
      &.active{
        background-color: $base-bgcolor-hover-blue; color: #fff;
        i{color: #fff;}
      }
    }
  }

  $subMenu-height: 40px;
  #subNavBox{
    position: relative; width: 230px; height: 100%; padding: 50px 0 0 50px;
    background-color: $menu-bgcolor-3; color: #333; font-size: 12px; overflow-x: hidden;
    transition: all 300ms;
    .menuTitle{height: 70px; line-height: 70px; padding-left: 20px; background-color: #d9dee4; font-weight: bold;}
    &.noSubMenu{width: 0px; overflow: hidden;}
    &.fold{width: 30px;}
    li{
      line-height: $subMenu-height; cursor: pointer;
      .nav-icon{float: left; width: 30px; height: $subMenu-height; text-align: center; font-size: 14px;}
      & > a{
        display: block; padding-left: 30px;
        &.active{background-color: #fff;/* color: $theme-color-blue;*/}
      }
      & > a:hover, & > div:hover{background-color: #f4f6f8;}
      div.folding + .thdNavBox{height: 0; overflow: hidden;}
    }
    .thdNavBox{
      li a{padding-left: 40px;}
    }
  }

  .hideMenu{
    position: absolute; right: 0; top: 50%; width: 30px; height: 50px; cursor: pointer; overflow: hidden;
    i.fa-chevron-left{position: absolute; left: 10px; top: 8px; font-size: 16px; color: #999;}
    .hm_bg-unfold{
      height: 50px; position: relative; left: 10px; transition: all 300ms;
      border-top: 10px solid transparent; border-right: 24px solid #f7f7f7;
      border-bottom: 10px solid transparent; border-left: none;
    }
    &:hover .hm_bg-unfold{left: 4px;}
    .hm_bg-fold{
      height: 50px; position: relative; right: 10px; transition: all 300ms;
      border-top: 10px solid transparent; border-right: none;
      border-bottom: 10px solid transparent; border-left: 24px solid $menu-bgcolor-3;
      i.indent{position: absolute; right: 10px; top: 7px; left: initial; transform: rotate(180deg);}
    }
    &:hover .hm_bg-fold{right: 4px;}
    &.fold{left: 50px; right: inherit; overflow: inherit;}
  }
</style>



// WEBPACK FOOTER //
// src/components/base/menuframe.vue